<template>
	<div id="app">
		<Header/>
		<!-- <router-view/> -->
		<transition name="fade" mode="out-in">
			<router-view/>
		</transition>
		<Footer/>
	</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  components: {
    Header,
    Footer,
  }

}

</script>

<style lang="sass">
#app
    font-family: 'Avenir', Helvetica, Arial, sans-serif
    -webkit-font-smoothing: antialiased
    -moz-osx-font-smoothing: grayscale
    text-align: center
    color: black
    background-color: #fefefe
    width: 100vw

</style>
<style lang="css">
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
